// import ProfilePage from './ProfilePage';
// export default ProfilePage;

import ProfileMobilePage from './ProfileMobilePage';
export default ProfileMobilePage;
